<footer>
  <div class="container">
    <div class="row d-flex justify-content-between align-items-center">
      <div class="text mt-4 mb-3">
        <p>جميع الحقوق محفوظة لدى خَيْرُكُمْ. 2021 &copy;</p>
      </div>
      
      <div class="media row">
        <div class="icons col-3">
          <a href="#"><i class="fab fa-facebook-f "></i></a>
        </div>
        
        <div class="icons col-3">
          <a href="#"><i class="fab fa-instagram"></i></a>
        </div>
         
        <div class="icons col-3">
          <a href="#"><i class="fab fa-twitter"></i></a>
        </div>
      </div>
    </div>
  </div>
</footer>